import { render, staticRenderFns } from "./DeleteAlertModal.vue?vue&type=template&id=9a50c2ee&scoped=true&"
import script from "./DeleteAlertModal.vue?vue&type=script&lang=js&"
export * from "./DeleteAlertModal.vue?vue&type=script&lang=js&"
import style0 from "./DeleteAlertModal.vue?vue&type=style&index=0&id=9a50c2ee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a50c2ee",
  null
  
)

export default component.exports